<template>
  <FormRow class="designation" inline>
    <FormSelect field="applications.0.campaign">
      <option selected="selected" value="Judah Fellowships">
        The Judah Fellowship College Campus Initiative
      </option>
      <option value="Beth Goldsammler">Beth Goldsammler Memorial Fund-Israel Fund</option>
      <option value="Camp Sports">Camp Sports</option>
      <option value="Gap Year Scholarship">
        Torah Fund Israel Gap Year Scholarships
      </option>      
      <option value="Gift of Yeshiva">
        Gift of Yeshiva
      </option>
      <option value="Bike Ride">Bike NCSY</option>
      <option value="Young Professionals Event">NCSY Alumni Professionals Events</option>
      <option value="Yarchei Kallah">Yarchei Kallah</option>
      <option value="General Donation">General Donation</option>
    </FormSelect>
    <ErrorLabel field="applications.0.campaign" style="text-align: right" />
  </FormRow>
</template>

<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
